const formatNumber = (value, decimalPlaces = 2) => {
  if (value === null || value === undefined || value === '-') {
    return value;
  }

  // Skip formatting for time strings (contain colon)
  if (typeof value === 'string' && value.includes(':')) {
    return value;
  }

  const num = parseFloat(value);
  if (isNaN(num)) {
    return value;
  }

  return num.toFixed(decimalPlaces);
};

export default formatNumber;